import React from 'react';
import { radii, typography, getActiveTheme } from './tokens';

export default function Chip({ label, className = '', style = {} }) {
  const theme = getActiveTheme();
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 text-xs ${className}`}
      style={{
        borderRadius: radii.round,
        background: theme.surface2,
        color: theme.text,
        border: `1px solid ${theme.border}`,
        fontSize: typography.meta.fontSize,
        lineHeight: typography.meta.lineHeight,
        ...style,
      }}
    >
      {label}
    </span>
  );
}
